export default __webpack_public_path__ + "static/media/Cart_Icon.d7877b9c.svg";